var map = {
	"./date.de-CH.json": 941,
	"./date.de-DE.json": 942,
	"./date.en-CA.json": 943,
	"./date.en-GB.json": 944,
	"./date.en-IN.json": 945,
	"./date.en-ME.json": 946,
	"./date.en-US.json": 947,
	"./date.es-EM.json": 948,
	"./date.es-ES.json": 949,
	"./date.fr-BE.json": 950,
	"./date.fr-CA.json": 951,
	"./date.fr-CH.json": 952,
	"./date.nl-BE.json": 953,
	"./date.nl-NL.json": 954,
	"./date.pl-PL.json": 955,
	"./date.pt-BR.json": 956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 940;